import { render, staticRenderFns } from "./MappingDialog.vue?vue&type=template&id=6aefa0f8&scoped=true"
import script from "./MappingDialog.vue?vue&type=script&lang=js"
export * from "./MappingDialog.vue?vue&type=script&lang=js"
import style0 from "./MappingDialog.vue?vue&type=style&index=0&id=6aefa0f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aefa0f8",
  null
  
)

export default component.exports